import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107109Status: 'idle',
    startProcess107109Error: undefined as any,
    loadUserParamsProcess107109Status: 'idle',
    loadUserParamsProcess107109Error: undefined as any,

    process107109List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107109 = createAsyncThunk('process107109Slice/startProcess107109', async ({ process107109 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107109/`,
        prepareData(process107109),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107109Status } = getState().process107109Slice
        return startProcess107109Status !== 'pending'
    }
})

export const loadUserParamsProcess107109 = createAsyncThunk('process107109Slice/loadUserParamsProcess107109', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107109/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107109Status } = getState().process107109Slice
        return loadUserParamsProcess107109Status !== 'pending'
    }
})

const Process107109Slice = createSlice({
    name: 'process107109Slice',
    initialState,
    reducers: {
        resetstartProcess107109: (state) => {
            state.job = undefined
            state.startProcess107109Error = undefined
        },
        resetstartProcess107109Error: (state) => {
            state.startProcess107109Error = undefined
        },
        resetloadUserParamsProcess107109: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107109Error = undefined
        },
        resetloadUserParamsProcess107109Error: (state) => {
            state.loadUserParamsProcess107109Error = undefined
        },
        removeFromProcess107109ListById: (state, action) => {
            state.process107109List = state.process107109List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107109ListByIds: (state, action) => {
            state.process107109List = state.process107109List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107109List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107109Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107109List = []
            state.startProcess107109Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107109.pending, (state) => {
            state.startProcess107109Status = 'pending'
            state.startProcess107109Error = undefined
        })
        builder.addCase(startProcess107109.fulfilled, (state, action) => {
            state.startProcess107109Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107109.rejected, (state, action) => {
            state.startProcess107109Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107109Error = action.error.message
            } else {
                state.startProcess107109Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107109.pending, (state) => {
            state.loadUserParamsProcess107109Status = 'pending'
            state.loadUserParamsProcess107109Error = undefined
        })
        builder.addCase(loadUserParamsProcess107109.fulfilled, (state, action) => {
            state.loadUserParamsProcess107109Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107109.rejected, (state, action) => {
            state.loadUserParamsProcess107109Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107109Error = action.error.message
            } else {
                state.loadUserParamsProcess107109Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107109,
    resetstartProcess107109Error,
    resetloadUserParamsProcess107109,
    resetloadUserParamsProcess107109Error,
    removeFromProcess107109ListById,
    removeFromProcess107109ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107109Slice.actions
export default Process107109Slice.reducer
